import {DateTimeInfo, TimezoneObject} from 'common/src/modules/timezones/timezones.types';
import {AccountProfile} from 'common/src/modules/clients/clients.types';
import {MutableRefObject} from 'react';
import {CLPromiseRef} from '../shared.types';
import Subject from 'common/src/utils/pubsub/subject';

const dateTimeInfo: MutableRefObject<DateTimeInfo | null> = {current: null};
const dateTimeInfoSubject = new Subject<DateTimeInfo | null>(null);
const fetchDateTimePromise: CLPromiseRef<[AccountProfile, TimezoneObject[]]> = {current: null};

export {dateTimeInfo, dateTimeInfoSubject, fetchDateTimePromise};
